import React from 'react';
import {css} from 'aphrodite';

export const renderModalField = (block, rowData, styleSheet, styleName, styleLabel) => {
  const className = styleSheet[styleName] ? css(styleSheet[styleName]) : '';

  return (
    <div className={className} key={block.property}>
      {block.label &&
          <div>
            <label className={css(styleSheet[styleLabel])}>{block.label}</label>
          </div>
      }
      {
        Array.isArray(rowData[block.property])
          ? (
            rowData[block.property].length > 0
              ? Object.values(rowData[block.property]).sort().join(', ')
              : block.default
          )
          : (
            rowData[block.property]
              ? rowData[block.property]
              : block.default
          )
      }
    </div>
  );
}